import { t } from "i18next";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Alert, Box, Button, Typography } from "@mui/material";

import { theme } from "@/src/theme/theme";

interface FeedbackSuccessStateProps {
  hasImageFailures?: boolean;
  onNewFeedback: () => void;
}

const FeedbackSuccessState = ({
  hasImageFailures,
  onNewFeedback
}: FeedbackSuccessStateProps) => {
  return (
    <Box sx={{ textAlign: "center", py: 4 }}>
      <CheckCircleIcon
        sx={{ fontSize: 64, color: theme.palette.semantic.success.main, mb: 2 }}
      />

      <Typography
        variant="h3"
        sx={{ mb: 2, color: theme.palette.semantic.success.main }}
      >
        {t("feedbackForm.successTitle")}
      </Typography>

      <Typography variant="body1" sx={{ mb: 2 }}>
        {t("feedbackForm.successMessage")}
      </Typography>

      {hasImageFailures && (
        <Alert severity="warning" sx={{ mb: 3 }}>
          {t("feedbackForm.error.imageUploadPartial")}
        </Alert>
      )}

      <Button variant="outlined" onClick={onNewFeedback} sx={{ mt: 2 }}>
        {t("feedbackForm.sendNewFeedback")}
      </Button>
    </Box>
  );
};

export default FeedbackSuccessState;
